var moduleMap = {
	"./infra": () => {
		return Promise.all(/* infra */[__webpack_require__.e(3366), __webpack_require__.e(3483), __webpack_require__.e(2965)]).then(() => (() => ((__webpack_require__(1103)))));
	},
	"./pages": () => {
		return Promise.all(/* page */[__webpack_require__.e(473), __webpack_require__.e(4324), __webpack_require__.e(5578), __webpack_require__.e(3366), __webpack_require__.e(1396), __webpack_require__.e(5769), __webpack_require__.e(5676), __webpack_require__.e(4382), __webpack_require__.e(9699), __webpack_require__.e(5921), __webpack_require__.e(9768)]).then(() => (() => ((__webpack_require__(27492)))));
	},
	"./components": () => {
		return Promise.all(/* components */[__webpack_require__.e(473), __webpack_require__.e(5578), __webpack_require__.e(3366), __webpack_require__.e(1396), __webpack_require__.e(5769), __webpack_require__.e(5676), __webpack_require__.e(4382), __webpack_require__.e(9699), __webpack_require__.e(5921), __webpack_require__.e(160)]).then(() => (() => ((__webpack_require__(78707)))));
	},
	"./runtime": () => {
		return Promise.all(/* runtime */[__webpack_require__.e(7721), __webpack_require__.e(17), __webpack_require__.e(3366), __webpack_require__.e(3483), __webpack_require__.e(7466), __webpack_require__.e(3666)]).then(() => (() => ((__webpack_require__(23663)))));
	},
	"./modern-runtime": () => {
		return Promise.all(/* modern-runtime */[__webpack_require__.e(7721), __webpack_require__.e(1396), __webpack_require__.e(7466), __webpack_require__.e(9224)]).then(() => (() => ((__webpack_require__(82378)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});